import {Injectable} from '@nestjs/common';
import { SaleOrderItems } from '../sale-order-items.entity';
import {SaleOrderItemsInfo} from './sale-order-items-info.model';

@Injectable()
export class SoItemsAdapter {
    /**
     * 
     * @param variantDto 
     * @param isUpdate 
     * @returns 
     */

    public convertDtoToEntity( soItemsDto: SaleOrderItemsInfo, isUpdate, percentageMap, barcode?:number): SaleOrderItems {
        console.log("jjjj");
        console.log(soItemsDto);
        console.log(isUpdate)
        let refNumber = barcode;
        let SoItemRefrNumber = barcode + "";
            while (SoItemRefrNumber.length < 6) SoItemRefrNumber = "0" + SoItemRefrNumber;
        const soItem = new SaleOrderItems();
        const finPercentage = percentageMap.get(soItemsDto.varientId).get(soItemsDto.soakingStyle)
        soItem.saleOrderId=soItemsDto.saleOrderId;
        soItem.itemId=soItemsDto.itemId;
        soItem.minGrade=soItemsDto.minGrade;
        soItem.maxGrade=soItemsDto.maxGrade;
        soItem.foodTypeId=soItemsDto.foodTypeId;
        soItem.valueAdditionOneId=soItemsDto.valueAdditionOneId;
        soItem.valueAdditionTwoId=soItemsDto.valueAdditionTwoId;
        soItem.valueAdditionThreeId=soItemsDto.valueAdditionThreeId;
        soItem.valueAdditionFourId=soItemsDto.valueAdditionFourId;
        soItem.valueAdditionFiveId=soItemsDto.valueAdditionFiveId;
        soItem.pouches=soItemsDto.pouches;
        soItem.cases=soItemsDto.cases;
        soItem.jobCases=soItemsDto.jobCases;
        soItem.caseWeight=soItemsDto.caseWeight;
        soItem.netWeight=soItemsDto.netWeight;
        soItem.netAmount=soItemsDto.netAmount;
        soItem.pouchWeight=soItemsDto.pouchWeight;
        soItem.categoryId=soItemsDto.categoryId;
        soItem.unitPrice=soItemsDto.unitPrice;
        soItem.category=soItemsDto.category;
        soItem.brandId=soItemsDto.brandId;
        soItem.uomId=soItemsDto.uomId;
        soItem.varientId=soItemsDto.varientId;
        soItem.innerBags=soItemsDto.innerBags;
        soItem.shrimpWeight=soItemsDto.shrimpWeight;
        soItem.minGlaze=soItemsDto.minGlaze;    
        soItem.MaxGlaze=soItemsDto.MaxGlaze;
        soItem.soakingTime=soItemsDto.soakingTime;
        soItem.soakingStyle=soItemsDto.soakingStyle;
        soItem.styleWeighment=soItemsDto.styleWeighment;
        soItem.finalPercentage=finPercentage;
        soItem.masterBrandId=soItemsDto.masterBrandId;
        soItem.requiredCount=soItemsDto.requiredCount;
        soItem.packStyleId=soItemsDto.packStyleId;
        soItem.reportedCases=soItemsDto.reportedCases;
        soItem.barcode = SoItemRefrNumber;
        soItem.refNumber = refNumber;
        soItem.isActive=soItemsDto.isActive==undefined?true:soItemsDto.isActive;
        if (isUpdate){
            soItem.saleOrderItemId=soItemsDto.saleOrderItemId;
            soItem.updatedUser = soItemsDto.updatedUser;
        }else {
            soItem.isActive = true;
            soItem.createdUser=soItemsDto.createdUser;
        }
        return soItem;
    }
    public convertEntityToDto( soItem: SaleOrderItems): SaleOrderItemsInfo{
        const soItemsDto = new SaleOrderItemsInfo();
        soItemsDto.saleOrderItemId=soItem.saleOrderItemId;
        soItemsDto.saleOrderId=soItem.saleOrderId;
        soItemsDto.itemId=soItem.itemId;
        soItemsDto.minGrade=soItem.minGrade;
        soItemsDto.maxGrade=soItem.maxGrade;
        soItemsDto.foodTypeId=soItem.foodTypeId;
        soItemsDto.valueAdditionOneId=soItem.valueAdditionOneId;
        soItemsDto.valueAdditionTwoId=soItem.valueAdditionTwoId;
        soItemsDto.valueAdditionThreeId=soItem.valueAdditionThreeId;
        soItemsDto.valueAdditionFourId=soItem.valueAdditionFourId;
        soItemsDto.pouches=soItem.pouches;
        soItemsDto.cases=soItem.cases;
        soItemsDto.caseWeight=soItem.caseWeight;
        soItemsDto.netWeight=soItem.netWeight;
        soItemsDto.netAmount=soItem.netAmount;
        soItemsDto.pouchWeight=soItem.pouchWeight;
        soItemsDto.categoryId=soItem.categoryId;
        soItemsDto.unitPrice=soItem.unitPrice;
        soItemsDto.brandId=soItem.brandId;
        soItemsDto.uomId=soItem.uomId;
        soItemsDto.isActive=soItem.isActive;
        soItemsDto.createdAt=soItem.createdAt;
        soItemsDto.createdUser=soItem.createdUser;
        soItemsDto.updatedAt=soItem.updatedAt;
        soItemsDto.updatedUser=soItem.updatedUser;
        soItemsDto.versionFlag=soItem.versionFlag;
        soItemsDto.reportedCases=soItem.reportedCases;
        soItemsDto.barcode=soItem.barcode;
        soItemsDto.packStyleId=soItem.packStyleId;
        return soItemsDto;
    }
}